import { useSelector } from "@tanstack/react-store"
import { monsterPromoStore } from "./store"

export function useMonsterPromoOpen(): boolean {
	return useSelector(monsterPromoStore, (state) => state.open)
}
